'use client';

import { blogOptions } from './constants';
import { SanityImageSource } from '@sanity/image-url/lib/types/types';
import imageUrlBuilder from '@sanity/image-url';
import { client } from '@/sanity/client';
import BlogPostType from '@/components/common/BlogPostType';
import { formatDate } from '@/utils';
import { useState } from 'react';
import Link from 'next/link';
import NoBlog from './NoBlog';

const BlogList = ({ posts }: { posts: any }) => {
  const [selectedBlogType, setSelectedBlogType] = useState('All');
  const [filteredPosts, setFilteredPosts] = useState(posts);

  const filterPosts = (postType: string) => {
    setSelectedBlogType(postType);
    if (postType === 'All') {
      setFilteredPosts(posts);
    } else {
      const filtered = posts.filter((post: any) => post.type === postType);
      setFilteredPosts(filtered);
    }
  };

  return (
    <div className="flex flex-col items-center gap-6 w-full">
      <span className="self-stretch text-[#324452] text-center text-3xl sm:text-4xl font-medium">
        Sixsense in News & Insights
      </span>
      <div className={`flex flex-col ${filteredPosts.length ? 'gap-6' : 'gap-12'} w-full`}>
        <div
          className="flex 
          items-center justify-center flex-wrap"
        >
          {blogOptions.map((blogOption) => {
            return (
              <div
                className={`whitespace-nowrap flex px-3 py-2 justify-center items-center gap-2.5 rounded cursor-pointer transition-all ${selectedBlogType === blogOption ? 'border border-[#C0D5F1] bg-[#D7E7FF]' : ''}`}
                onClick={() => filterPosts(blogOption)}
                key={blogOption}
              >
                <span className="text-[#212A31] text-sm sm:text-base font-medium leading-6">
                  {blogOption}
                </span>
              </div>
            );
          })}
        </div>
        {filteredPosts.length > 0 && (
          <div
            className=" grid 
          grid-cols-1 
          sm:grid-cols-2 
          lg:grid-cols-3 
          gap-7 
          w-full"
          >
            {filteredPosts.map((post: any) => {
              const { projectId, dataset } = client.config();
              const urlFor = (source: SanityImageSource) =>
                projectId && dataset ? imageUrlBuilder({ projectId, dataset }).image(source) : null;
              const url = urlFor(post.ThumbnailImage)?.width(960).auto('format').url();
              return (
                <Link
                  className="flex flex-col items-center rounded-lg bg-[#FAFCFF] cursor-pointer border border-[#D7E7FF] hover:shadow-md transition-shadow"
                  href={`/blog/${post.slug.current}`}
                  key={post.slug.current}
                >
                  <img
                    src={url || ''}
                    alt={post.alt || ''}
                    className="w-full h-56 sm:h-64 lg:h-72 object-cover rounded-t-lg"
                  />
                  <div className="flex flex-col px-3 pt-3 pb-5 items-start gap-3 self-stretch">
                    <BlogPostType post={post} />
                    <span
                      className="self-stretch text-[#212A31] text-lg font-bold leading-snug line-clamp-2"
                      title={post.title}
                    >
                      {post.title}
                    </span>
                    <p
                      className="self-stretch text-[#212A31] text-sm sm:text-base leading-6 line-clamp-3"
                      title={post.summary}
                    >
                      {post.summary}
                    </p>
                    <span className="text-[#627C93] text-sm leading-[21px]">{post.PostedBy}</span>
                    <span className="text-[#627C93] text-sm leading-[21px]">
                      {formatDate(post.UpdatedAt)}
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
        {filteredPosts.length === 0 && <NoBlog />}
      </div>
    </div>
  );
};

export default BlogList;
